import { API_BASE_URL } from '../config/apiEndpoints';

const BRIEF_ID_STORAGE_KEY = 'occasia_venue_brief_id';

export const storeVenueBriefId = (briefId) => {
  if (!briefId) return;
  try {
    localStorage.setItem(BRIEF_ID_STORAGE_KEY, String(briefId));
  } catch {
    // Ignore storage errors.
  }
};

export const getStoredVenueBriefId = () => {
  try {
    return localStorage.getItem(BRIEF_ID_STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

const normalizeBriefs = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const fetchBriefById = async (briefId) => {
  const response = await fetch(`${API_BASE_URL}/forms/venue-brief/${briefId}`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) return null;
  return response.json();
};

const briefBelongsToUser = (brief, normalizedEmail) => {
  if (!brief || !normalizedEmail) return false;
  const briefEmail = String(brief.contact_email || '').trim().toLowerCase();
  return briefEmail === normalizedEmail;
};

const mergeBriefForUser = (brief, normalizedEmail, results) => {
  const id = brief?.id || brief?.brief_id;
  if (!id || brief.deleted_at) return;
  if (!briefBelongsToUser(brief, normalizedEmail)) return;
  if (!results.some((item) => (item.id || item.brief_id) === id)) {
    results.push(brief);
  }
};

export const fetchUserVenueBriefs = async (email) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  if (!normalizedEmail) return [];

  const results = [];
  const storedId = getStoredVenueBriefId();

  if (storedId) {
    try {
      const brief = await fetchBriefById(storedId);
      if (brief && !briefBelongsToUser(brief, normalizedEmail)) {
        try {
          localStorage.removeItem(BRIEF_ID_STORAGE_KEY);
        } catch {
          // Ignore storage errors.
        }
      } else {
        mergeBriefForUser(brief, normalizedEmail, results);
      }
    } catch {
      // Continue to list fetch.
    }
  }

  try {
    // Note: list endpoint currently ignores contact_email — always filter client-side.
    const response = await fetch(`${API_BASE_URL}/forms/venue-brief?limit=50`, {
      headers: { Accept: 'application/json' },
    });

    if (response.ok) {
      const data = await response.json();
      normalizeBriefs(data).forEach((brief) => mergeBriefForUser(brief, normalizedEmail, results));
    }
  } catch {
    // Return whatever we have from stored id lookup.
  }

  return results;
};

export const getActivePendingBrief = (briefs) => {
  if (!Array.isArray(briefs) || briefs.length === 0) return null;
  const pending = briefs.filter((brief) => {
    if (brief.deleted_at) return false;
    if (brief.venue_finalized) return false;
    if (brief.linked_booking_id) return false;
    return true;
  });
  if (pending.length === 0) return null;
  return pending.sort((a, b) => {
    const aTime = new Date(a.updated_at || a.created_at || 0).getTime();
    const bTime = new Date(b.updated_at || b.created_at || 0).getTime();
    return bTime - aTime;
  })[0];
};
